<template>
  <div class="u-text-align-left">
    <div
      v-for="(item, index) in menu"
      :key="index"
      class="c-list-item u-margin-top"
    >
      <h5>{{ $t(item.title) }}</h5>
      <ul class="c-list">
        <router-link
          :to="sub.path"
          class="c-list__item"
          v-for="(sub, j) in item.sub"
          :key="j + '-' + index"
        >
          <span>
            <i :class="`icofont-${sub.icon} u-margin-right-small`"></i>
            {{ $t(sub.title) }}</span
          >
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import menu from "./menu.json";
export default {
  data() {
    return {
      menu,
    };
  },
  watch: {
    $route() {
      this.$emit("show:menu", false);
    },
  },
};
</script>

<style></style>
